/**
 * 창조신 김마고 - 브라우저 진입점 (React)
 */

import React from 'react';
import { createRoot } from 'react-dom/client';
import { createGameAPI } from '@app-games/api';
import { createGameCore } from './game/index.js';
import { App } from './view/App.js';

const isDev = import.meta.env.DEV;
const core = createGameCore(isDev);

createGameAPI(core, {
  exposeGlobal: isDev,
  debug: isDev
});

// 게임 루프
let lastTime = performance.now();
function gameLoop() {
  const now = performance.now();
  const deltaTime = (now - lastTime) / 1000;
  lastTime = now;
  core.tick(deltaTime);
  requestAnimationFrame(gameLoop);
}
gameLoop();

// React 렌더링
createRoot(document.getElementById('app')!).render(
  <React.StrictMode>
    <App core={core} />
  </React.StrictMode>
);

if (isDev) {
  console.log('[Mago] Dev mode - use GameAPI in console');
}
